/**
 * next.js
 * Written by: Brian Kim
 */
import quizActions from '../../../quiz/actions';
import questionActions from '../../actions';

/**
 * Description of the next reducer
 */
const next = (state = null, action) => {
  switch (action.type) {
    case questionActions.SELECT_NEXT_QUESTION_SUCCESS:
      return action.id;
    case questionActions.SELECT_NEXT_QUESTION_FAILURE:
    case quizActions.GET_QUIZ_START:
      return null;
    default:
      return state;
  }
};

export default next;
